(() => {
  const productCache = new Map();
  const colourSwatchCache = new Map();
  let clickRun = 0;

  function getInputLabel(input) {
    if (!input || !input.id) return null;

    const picker = input.closest("variant-picker");
    const selector = `label[for="${CSS.escape(input.id)}"]`;

    return picker?.querySelector(selector) || document.querySelector(selector);
  }

  function getInputText(input) {
    const label = getInputLabel(input);
    return label ? label.textContent.trim() : "";
  }

  function getFormInputs(form) {
    return Array.from(form.elements).filter(
      (element) =>
        element.matches &&
        element.matches("input[data-option-position]")
    );
  }

  function getMainProductPicker() {
    return document.querySelector(
      'variant-picker[context="main_product"]'
    );
  }

  function cacheColourSwatches() {
    const picker = getMainProductPicker();

    if (!picker) return;

    picker
      .querySelectorAll(
        'input[data-option-position="1"] + label.thumbnail-swatch'
      )
      .forEach((label) => {
        const name = label.textContent.trim();
        const image = label.querySelector("img");

        if (name && image) {
          colourSwatchCache.set(name, label.innerHTML);
        }
      });
  }

  function restoreColourSwatches() {
    const picker = getMainProductPicker();

    if (!picker) return;

    picker
      .querySelectorAll('input[data-option-position="1"] + label')
      .forEach((label) => {
        const name = label.textContent.trim();
        const cachedHtml = colourSwatchCache.get(name);

        if (!name || !cachedHtml || label.querySelector("img")) return;

        const isDisabled = label.classList.contains("is-disabled");

        label.innerHTML = cachedHtml;
        label.className = `thumbnail-swatch${
          isDisabled ? " is-disabled" : ""
        }`;
      });
  }

  async function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`/products/${handle}.js`).then((response) => response.json())
      );
    }

    return productCache.get(handle);
  }

  async function selectColourAndBestAvailableSize(colourInput, runId) {
    if (!colourInput || colourInput.disabled) return;

    cacheColourSwatches();

    const formId = colourInput.getAttribute("form");
    const form = document.forms[formId];
    const picker = document.querySelector(
      `variant-picker[form-id="${CSS.escape(formId)}"]`
    );

    if (!form || !picker) return;

    const handle = picker.getAttribute("handle");
    const selectedColour = getInputText(colourInput);

    if (!handle || !selectedColour) return;

    const product = await getProduct(handle);

    if (runId !== clickRun) return;

    const currentSizeInput = getFormInputs(form).find(
      (input) =>
        input.getAttribute("data-option-position") === "2" &&
        input.checked
    );

    const currentSize = getInputText(currentSizeInput);

    let bestVariantForColour = product.variants.find(
      (variant) =>
        variant.available &&
        variant.option1 === selectedColour &&
        variant.option2 === currentSize
    );

    if (!bestVariantForColour) {
      bestVariantForColour = product.variants.find(
        (variant) =>
          variant.available &&
          variant.option1 === selectedColour
      );
    }

    if (!bestVariantForColour) return;

    const requiredSize = bestVariantForColour.option2;

    const sizeInput = getFormInputs(form)
      .filter(
        (input) =>
          input.getAttribute("data-option-position") === "2"
      )
      .find((input) => getInputText(input) === requiredSize);

    colourInput.checked = true;

    if (sizeInput) {
      sizeInput.checked = true;
    }

    colourInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );

    setTimeout(restoreColourSwatches, 100);
    setTimeout(restoreColourSwatches, 300);
    setTimeout(restoreColourSwatches, 600);
  }

  document.addEventListener(
    "click",
    (event) => {
      const label = event.target.closest("label");

      if (!label) return;

      const input = document.getElementById(
        label.getAttribute("for")
      );

      if (
        !input ||
        !input.matches(
          'variant-picker[context="main_product"] input[data-option-position="1"]'
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      clickRun += 1;
      selectColourAndBestAvailableSize(input, clickRun);
    },
    true
  );

  cacheColourSwatches();
})();